import React, { Component } from 'react';
import Swal from 'sweetalert2'
import qs from 'qs'
import ip from 'ip'
import { Link } from 'react-router-dom'
import lton from 'letter-to-number';


import './Input.css'
import wordToResult from '../helper/wordToNumberToSwitchCase'


const { fire } = require('../fire')

const db = fire.firestore();
const settings = {timestampsInSnapshots: true};
db.settings(settings);

class Input extends Component {

  state={
    myName:'',
    otherName:'',
    timesPush:0,
  }

  componentDidMount=()=>{
    const parsed = qs.parse(window.location.search);
    console.log(parsed)
    this.setState({userId:parsed['?u']})
  }

  changeMyName=(e)=>{
    this.setState({myName:e.target.value})
  }
  changeOtherName=(e)=>{
    this.setState({otherName:e.target.value})
  }


  
  handleClick = (e) => {
    
    e.preventDefault();
    console.log('The link was clicked.');
    console.log(this.state)
    if(this.state.userId){
      //以下會先判斷，是不是一直重複打超過100次
      let timesPush=this.state.timesPush
      console.log(timesPush)
      timesPush=timesPush+1
      this.setState({
        timesPush
      })
      if(timesPush>150){
        alert('請別用非法手段攻擊本網站。')
      }else{
        var upperHashUserId = this.state.userId.toUpperCase();//要先轉大寫才能使用
        var userId = lton(upperHashUserId)?lton(upperHashUserId).toString():'';
        // console.log('userId::',userId)
        
        if(userId){
          const myName = this.state.myName
          const otherName = this.state.otherName
          var docRef = db.collection("member").doc(userId);
          
          docRef.get().then(function(doc) {
            console.log(doc)
            if (doc.exists) {
              let InfoRef = db.collection('likeData').add({
                myName,otherName,push:false,userId,timestamp:new Date()
              })
            }
          })
        }
      }
      
    }

    const resultTest = wordToResult(this.state.myName,this.state.otherName)
    

    Swal({
      title: '打開卷軸',
      text: `${this.state.myName}與${this.state.otherName}的結果報告書`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Open it!',
      cancelButtonText: 'No, Delete it'
    }).then((result) => {
      if (result.value) {
        
        Swal({
          title:`速配指數${resultTest[0]}%`,
          html:resultTest[1],
          type:'success'
        })
      // For more information about handling dismissals please visit
      // https://sweetalert2.github.io/#handling-dismissals
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal(
          'Cancelled',
          'The result is deleted :)',
          'error'
        )
      }
    })
    this.setState({myName:'',otherName:''})
  };
  
  
  render() {
    return (
      <div>
        <h1>超神準姓名學!愛情配對</h1>
        <div className="wrap">
          <input type="text" placeholder="請輸入自己的名字" onChange={this.changeMyName} value={this.state.myName} ></input>
          <div className="bg"></div>
        </div>
        <div className="wrap2">
          <input type="text" placeholder="請輸入喜歡的人名字" onChange={this.changeOtherName} value={this.state.otherName}></input>
          <div className="bg2"></div>
        </div>
        <div className="divButton">
          <a className="ghost_btn semi-transparent" href="#"  onClick={this.handleClick}>測驗</a>
        </div>
        <div className='wrap3'>
          <p style={{color:'#b2bec3'}}>點擊測驗代表你同意本網站
            <a><Link  style={{color:'#dfe6e9'}} to='/service-terms'>使用條款</Link></a>
            。
          </p>
        </div>
      </div>
    );
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input.js